import React, { FC } from 'react';
import { useStyles } from '@wix/tpa-settings/react';
import {
  useChannel,
  useChannelAccessButton,
  usePlayChannelText,
} from '../../../../hooks';
import stylesParams from '../../../../../../stylesParams';
import { Overlay, OverlayHeader, OverlayHeaderTitle } from '../Overlay/Overlay';

const useViewSettings = () => {
  const styles = useStyles();
  const showTitle = styles.get(stylesParams.showTitleForMainItem);

  return { showTitle };
};

export const ChannelOverlay: FC = () => {
  const playChannelText = usePlayChannelText();
  const channelAccessButton = useChannelAccessButton();
  const channel = useChannel();
  const { showTitle } = useViewSettings();

  const videoUrl = channel.play.entity.url;

  return (
    <Overlay
      playButtonText={playChannelText}
      paidButton={channelAccessButton}
      coverUrl={channel.cover.selected}
      videoUrl={videoUrl}
      content={
        showTitle ? (
          <OverlayHeader>
            <OverlayHeaderTitle>{channel.title}</OverlayHeaderTitle>
          </OverlayHeader>
        ) : null
      }
    />
  );
};
